import React, { useMemo, useState, useEffect } from "react";
import axios from "axios";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const scores2 = [32, 48, 15, 4, 21, 25, 4, 33, 9];
const labels = [
  "Introducción a la Innovación",
  "Negocios",
  "Marketing y Turismo",
  "Derecho",
  "Programación Junior",
  "Programación Intermedia y Avanzada",
  "Electrónica/Automatización/Robótica",
  "Introducción al Desarrollo de Páginas Web",
  "Producción Industrial",
];

const options = {
  fill: true,
  responsive: true,
  scales: {
    y: {
      min: 0,
    },
  },
  plugins: {
    legend: {
      display: true,
    },
  },
};

export default function ProjectsChart({total, sortedProjects}) {

  const data = useMemo(function () {
    
    return {
      datasets: [
        {
          label: document.title + " (" + total + ")",
          data: sortedProjects,
          tension: 0.3,
          borderColor: "rgb(75, 192, 192)",
          pointRadius: 8,
          pointBackgroundColor: "rgb(75, 192, 192)",
          backgroundColor: "rgba(75, 192, 192, 0.3)",
        },
        {
          label: "Feria Ingenio 2022-2 (191)",
          tension: 0.3,
          data: scores2,
          borderColor: "green",
          pointRadius: 8,
          pointBackgroundColor: "green",
          backgroundColor: "rgba(0, 255, 0, 0.3)",
        },
      ],
      labels,
    };
  }, [sortedProjects]);

  return <Line data={data} options={options} />;
}
